// Keys for banners that dismiss after N clicks (used with bannerCloseCount in dashboard slice)
export enum DismissCountBanners {
  ReviewBanner = 'review_banner',
}

export enum ClosedBanners {
  NationalDayHolidayClosure = 'national_day_holiday_closure ',
  CrossSellAppFeature = 'cross_sell_app_feature',
  LunarNewYearHoliday = 'lunar_new_year_holiday',
  ReunificationDay2025 = 'reunification_day_2025',
  SummerTravel2025 = 'summer_travel_2025',
  IndependenceDay2025 = 'independence_day_2025',
}

export enum AppKeyEnum {
  Return = 'return',
  PaypalTracking = 'paypal_tracking',
  OrderTracking = 'order_tracking',
  LlmIndex = 'llm_index',
  DingDoong = 'ding_doong',
  Estimated = 'estimated',
  Floatify = 'floatify',
  ChatForm = 'chat_form',
  BlockifyFraud = 'blockify_fraud',
  BlockifyCheckoutRules = 'blockify_checkout_rules',
  BlockifyAgeVerification = 'blockify_age_verification',
  BlockifyRecordReplay = 'blockify_record_replay',
}
export enum PlatformEnum {
  Shopify = 'shopify',
  Wix = 'wix',
  Woo = 'woo',
  Shopline = 'shopline',
}
export enum BannerToneEnum {
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Critical = 'critical',
}
